import React, { useEffect, useState } from "react";
import { useAlert } from "react-alert";
import { Link } from "react-router-dom";
import dataServices from "../../apiServices/data.services";
import Loader from "../../components/Loader/Loader";
import { handleValidationError, showAlert } from "../../components/CommonFunctions";
import { Can } from "../../context/AuthProvider";

const Plans = () => {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(false);
  const alert = useAlert();

  useEffect(() => {
    setLoading(true);
    dataServices
      .getPlans()
      .then((res) => {
        if (res.status === 200) {
          setPlans(res.data);
        }
      })
      .catch((err) => {
        alert.error(handleValidationError(err));
      })
      .finally(() => {
        setLoading(false);
      });
  }, [alert]);

  const handleDelete = (id) => {
    dataServices
      .deletePlan(id)
      .then((res) => {
        if (res.status === 200 || res.status === 204) {
          setPlans(plans.filter((plan) => plan.id !== id));
          alert.success("Plan deleted successfully");
        }
      })
      .catch((err) => {
        alert.error(handleValidationError(err));
      });
  };

  return (
    <div className="content-wrapper">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h6 className="mb-2 pb-1 px-3 fw-bold text-black">Plans</h6>
        <Can I="add" this="Plan">
          <Link to="/add-plan" className="btn btn-primary">
            Add Plan
          </Link>
        </Can>
      </div>
      <Can I="list" this="Plan">
        <div className="list">
          {plans.length > 0 ? (
            plans.map((plan) => (
              <div
                className="list-item d-flex justify-content-between align-items-center"
                key={plan.id}
              >
                <div className="w-100">
                  <div className="d-flex justify-content-between align-items-start">
                    <div>
                      <h6 className="mb-1 fs-14">{plan.name}</h6>
                      <small className="text-muted">{plan.description || "No description"}</small>
                      <br />
                      <strong>Price:</strong> ₹{plan.price} | <strong>Cycle:</strong> {plan.billing_cycle}
                    </div>
                    <small className={`badge ${plan.status === "active" ? "bg-success" : "bg-secondary"}`}>
                      {plan.status}
                    </small>
                  </div>
                  <div className="mt-2 d-flex gap-2">
                    <Can I="edit" this="Plan">
                      <Link className="btn btn-sm btn-outline-primary" to={`/edit-plan/${plan.id}`}>
                        Edit
                      </Link>
                    </Can>
                    <Can I="delete" this="Plan">
                      <button
                        className="btn btn-sm btn-outline-danger"
                        onClick={() => showAlert("Plan", handleDelete, plan.id)}
                      >
                        Delete
                      </button>
                    </Can>
                  </div>
                </div>
              </div>
            ))
          ) : loading ? (
            <Loader />
          ) : (
            <p className="px-3">No plans found.</p>
          )}
        </div>
      </Can>
    </div>
  );
};

export default Plans;
